import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchDeleteGroupFailure,
  fetchDeleteGroupSuccess,
} from "../slices/features/deleteContact";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchDeleteGroupSaga(action: any) {
  const { payload } = action;
  const { id, groupId, meta } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteGroup,
      baseUrl,
      id,
      groupId,
      meta
    );

    yield put(fetchDeleteGroupSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchDeleteGroupFailure({ statusCode, statusText }));
  }
}

export function* watchfetchDeleteGroup() {
  yield takeLatest(RequestTypes.DELETE_GROUP_REQUEST, fetchDeleteGroupSaga);
}
